import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const Testimonials = ({ content }) => {
  const { t } = useLang();
  const items = content?.items || [];
  if (items.length === 0) return null;
  const title = content?.title || t("testimonials.fallbackTitle");
  return (
    <section id="stories" data-testid="testimonials-section" className="py-24 bg-secondary/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-primary mb-5">{t("testimonials.eyebrow")}</p>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-foreground leading-tight mb-14 max-w-2xl">{title}</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <motion.blockquote key={i}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-card border border-border p-8 flex flex-col">
              <Quote className="text-primary/40 mb-4" size={28} />
              <p className="font-serif text-xl leading-relaxed text-foreground flex-1">"{it.quote || it.text}"</p>
              <footer className="mt-6 text-sm">
                <span className="font-semibold text-foreground">{it.name || it.author}</span>
                {it.role ? <span className="text-muted-foreground"> · {it.role}</span> : null}
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
